// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExceptionOutlinedSvg from "@fishx/icons-svg/es/asn/ExceptionOutlined";
import FishxIcon from '../components/FishxIcon';

var ExceptionOutlined = function ExceptionOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExceptionOutlinedSvg
  }));
};

ExceptionOutlined.displayName = 'ExceptionOutlined';
export default React.forwardRef(ExceptionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExceptionOutlined.js
// module id = 2623
// module chunks = 0